import React from 'react';
import './App.scss';
import Header from './Component/Header'

function App() {
  return (
    <div className="App">
      <Header/>
    </div>
  );
}

export default App;
